import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'patient-assessment-guid',
  imports: [],
  templateUrl: './assessment-guid.component.html',
  styleUrl: './assessment-guid.component.css'
})
export class AssessmentGuidComponent {

  private router = inject(Router);


  constructor() { }




  onStartAssessment(){

    this.router.navigate(['/create-appointment']);

  }

}
